import Fetchers from 'core/fetchers';
import ApplicationController from './application_controller';

export default class SignInController extends ApplicationController {
  static targets = ['input', 'toggleReCaptchaDiv']
  static values = { secureLoginUrl: String }

  initialize() {
    this.debouncedValidateOnInput = this.debounce(this.checkEmail.bind(this), 1000);
    this.debouncedValidateOnKeyup = this.debounce(this.validateOnKeyup.bind(this), 300);
  }

  connect() {
    this.toggleReCaptchaDivTarget.style.display = 'none'
    if (this.hasInputTarget && this.inputTarget.value.trim() !== '') {
      this.checkEmail()
    }
  }

  // Captures backspace and delete keyup events
  validateOnKeyup(event) {
    if (event.key !== 'Backspace' && event.key !== 'Delete') return;
    this.checkEmail()
  }

  checkEmail() {
    const email = this.inputTarget.value

    if (email === '') return

    const url = `${this.secureLoginUrlValue}?email=${encodeURIComponent(email)}`
    Fetchers.fetchJSON(url, 'GET', null)
      .then(res => res.json())
      .then((data) => {
        this.displayReCaptcha(data)
      })
      .catch(error => {
        console.error('Error checking email:', error)
        this.toggleReCaptchaDivTarget.classList.add('hidden')
      });
  }

  displayReCaptcha(data) {
    if (data.show) {
      this.toggleReCaptchaDivTarget.style.display = ''
    } else {
      this.toggleReCaptchaDivTarget.style.display = 'none'
    }
  }

  debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }
}
